import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import DynamicDropdown from "components/Elements/DynamicDropdown";
import { useFilters } from "../FilterContext";
import { useFilterInitialization } from "./hooks/useFilterInitialization";
import { SHOW_ALL_OPTION } from "../constants";

// Audit History logical actions (EMI3-1460). "deleted" covers soft and hard
// deletes still in effect; later-restored deletes appear under Restored/Show All.
const buildActionOptions = (t) => [
	SHOW_ALL_OPTION,
	{ id: "created", name: t("option.auditActionCreated") },
	{ id: "updated", name: t("option.auditActionUpdated") },
	{ id: "deleted", name: t("option.auditActionDeleted") },
	{ id: "restored", name: t("option.auditActionRestored") },
];

const toParams = (item) => ({ actions: item.id ? [item.id] : [] });

export const ActionTypeFilter = () => {
	const { filterValues, updateFilter } = useFilters();
	const { t } = useTranslation();
	const actionOptions = useMemo(() => buildActionOptions(t), [t]);

	useFilterInitialization("actionType", actionOptions, {
		waitForData: false,
		getDefaultValue: () => SHOW_ALL_OPTION,
		getParams: toParams,
		getReportParams: toParams,
	});

	if (!filterValues.actionType) {
		return null;
	}

	const handleChange = (item) => {
		updateFilter("actionType", item, toParams(item), true, toParams(item));
	};

	return (
		<Grid item lg={3} md={6} xs={12}>
			<DynamicDropdown
				dataSource={actionOptions}
				columns={[{ name: "name", id: 1 }]}
				showHeader={false}
				width="100%"
				placeholder={t("placeholder.selectAction")}
				onChange={handleChange}
				selectdValueToshow="name"
				selectedValue={filterValues.actionType?.value}
				label={t("label.filterByAction")}
				icon={<FilterListIcon style={{ color: "rgb(48, 122, 215)" }} />}
				required={false}
				showBorderColor
			/>
		</Grid>
	);
};
